import { render, staticRenderFns } from "./SimulationSubmissionList.vue?vue&type=template&id=0a9d564a&"
import script from "./SimulationSubmissionList.vue?vue&type=script&lang=js&"
export * from "./SimulationSubmissionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports